/* eslint-disable no-console */
import Layer from 'services/models/Layer';
import geoAlert from 'services/utils/customAlert';

import layerStyles from 'views/MapView//services/symbologiesStylesAnaliseRemota.json';

import axios from 'axios';
import GeoBahiaLoader from 'components/GeoBahiaLoader';
import L from 'leaflet';
import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useMap } from 'views/MapView/hooks';

const AnaliseRemota = ({ ...props }) => {

    const history = useHistory();

    const [salt, setSalt] = useState('');
    const [tokenUrl, setTokenUrl] = useState('');
    const [idAlertaInema, setIdAlertaInema] = useState(null);
    const [loading, setLoading] = useState(false);

    const { addLayer, map, layers, removeLayer, loadingMap } = useMap();

    const getURI = () => {
        return window.location.href.split('/').slice(3).join('/');
    };

    const getCurrentDateTimePtBr = () => {
        let localDate = new Date().toLocaleString('pt-BR');
        return localDate.substr(0, 10) + " " + localDate.substr(11, 20);
    };

    const redirectToFeedback = useCallback((withParams = true, situation, clientIp) => {
        let paramsToRedirectAccess =
            withParams
                ? {
                    situation: situation
                        ? situation
                        : 'Parâmetros incorretos',
                    url: getURI(),
                    dateTime: getCurrentDateTimePtBr(),
                    clientIp: clientIp
                        ? clientIp
                        : '-',
                }
                : null;
        history.push('/feedback/analise-remota', { ...paramsToRedirectAccess, });
    }, [history]);

    const verification = useCallback(() => {
        let params = {}
        params.salt = salt;
        params.token = tokenUrl;

        axios.get(`${process.env.REACT_APP_API_GEOSEIA_HOST}/analise?`, { params })
            .then((response) => {
                if (response.data.valid) {
                    return redirectToFeedback(true, response.data.valid, response.data.ipCliente)
                }

                if (response.data.codigoPerfilUsuario === 'ATEIN') {
                    geoAlert({
                        title: 'Seja Bem Vindo!',
                        message: 'Você acessou com perfil de Fiscal!',
                        buttonText: 'Continuar',
                    });
                }

                setIdAlertaInema(response.data.idAlertaInema);
            })
            .catch((error) => {
                console.error('Erro na requisição:', error);
                return redirectToFeedback(true, error.response.data.detail ? error.response.data.detail : 'Erro na requisição', '-');
            });

    }, [redirectToFeedback, salt, tokenUrl])

    const addGeoJSONLayer = useCallback(
        (geojson, style, name, paramType) => {
            const customRender = L.canvas({ pane: 'mixedPane' });

            let options = {
                pane: 'mixedPane',
                renderer: customRender,
                style: style,
            };

            const geoJsonLayer = L.geoJSON(geojson, options);

            let layerToAdd = new Layer(null, paramType, null, name, null, null, null, null, null);
            layerToAdd.setFileType('GeoJSON');
            layerToAdd.setLeafletLayer(geoJsonLayer);
            layerToAdd.setLayerStyle(style);
            addLayer(layerToAdd, null, false);

            return layerToAdd;
        },
        [addLayer]
    );

    const loadAlert = () => {
        axios.get(`${process.env.REACT_APP_API_ANALISE_REMOTA_HOST}/alertas/${idAlertaInema}/geom`)
            .then((response) => {
                const numero = response.data.properties.numero_registro_fiscalizacao.split('/')[0];
                const layer = addGeoJSONLayer(response.data, layerStyles[0], `RF - ${numero}`, 'importada');
                if (map && layer?.leafletLayer) {
                    map.flyToBounds(layer.leafletLayer.getBounds());
                }

                const imovelId = response.data.properties.cefir_ide_imovel;
                if (imovelId) {
                    loadCefir(imovelId)
                    loadRL(imovelId)
                }
            })
            .catch((err) => {
                console.log('Erro ao carregar Alerta: ' + err)
            })
    };

    const loadCefir = (imovelId) => {
        axios.get(`${process.env.REACT_APP_API_ANALISE_REMOTA_HOST}/cefir/${imovelId}/geom`)
            .then((response) => {
                const layer = addGeoJSONLayer(response.data, layerStyles[1], `Imóvel CEFIR - ${imovelId}`, 'importada');
                if (map && layer?.leafletLayer) {
                    map.flyToBounds(layer.leafletLayer.getBounds());
                }
            })
            .catch((err) => {
                console.log('Erro ao carregar CEFIR: ' + err)
            })
    };

    const loadRL = (imovelId) => {
        axios.get(`${process.env.REACT_APP_API_ANALISE_REMOTA_HOST}/cefir/${imovelId}/reserva-legal/geom`)
            .then((response) => {
                addGeoJSONLayer(response.data, layerStyles[2], `Reserva Legal - ${imovelId}`, 'importada');
            })
            .catch((err) => {
                console.log('Erro ao carregar Reserva Legal: ' + err)
            })
    };

    // Pega parametros da url e verifica os parametros obrigatorios
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const saltParam = urlParams.get('salt');
        const tokenParam = urlParams.get('token');

        if (!saltParam && !tokenParam) return redirectToFeedback(false);
        if (!saltParam || !tokenParam) return redirectToFeedback(true, 'É necessário enviar os parâmetros obrigatórios: salt e token.', '-');

        setSalt(urlParams.get('salt'));
        setTokenUrl(urlParams.get('token'));
    }, [redirectToFeedback]);

    // Responsalvel por remover as camadas inicias do modulo e depois carregar as camadas individuais
    useEffect(() => {
        const fetchData = async () => {
            if (!idAlertaInema) return;
            setLoading(true);

            // Limpa camadas iniciais
            if (layers.length > 0 && !loadingMap) {
                layers.forEach((layer) => {
                    if (
                        layer.alias === "Alertas INEMA Agosto" ||
                        layer.alias === "Divisão Político Administrativa - SEI"
                    ) {
                        removeLayer(layer.id);
                    }
                });

                loadAlert();
            }

            setLoading(false);
        };

        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingMap]);

    useEffect(() => {
        if (salt || tokenUrl) {
            verification()
        }
    }, [salt, tokenUrl, verification])

    return (
        <>
            <GeoBahiaLoader open={loading} />
        </>
    );
};

AnaliseRemota.properties = {
    id: 'CPN-MA-ANALISE-REMOTA',
    alias: 'Análise Remota',
    description: '...',
};

export default AnaliseRemota;
